export default __webpack_public_path__ + "static/m-kevin-1fd600c924db1584cd3b81aa6cdf83da.png";